export default function file() {
  'ngInject'
  var directive = {
    restrict: 'AE',
    scope: {
      file: '@',
    },
    link: fileLink,
  }

  return directive

  function fileLink(scope, iElement) {
    iElement.bind('change', function(event) {
      var files = event.target.files
      var file = files[0]
      scope.file = file
      scope.$parent.file = file
      if (!scope.$root.files) {
        scope.$root.files = {}
      }
      scope.$root.files[this.name] = file
      scope.$apply()
    })
  }
}
